import React, { Component } from 'react';

import axios from 'axios';

import { Field, reduxForm, change } from 'redux-form';
import { Modal, Button, Row, Col, Checkbox } from 'react-bootstrap';

import PdfBody from './PdfBody';

require(`../assets/${process.env.PAGE}/css/contract.css`);
require(`../assets/${process.env.PAGE}/css/custom-modal.css`);

class Contract extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            contractText: null,
            link: null,
        };

        this.acceptContract = this.acceptContract.bind(this);
        this.closeContract = this.closeContract.bind(this);
        this.openContract = this.openContract.bind(this);
    }

    componentWillMount() {
        if (!this.props.hasOwnProperty('text')) {
            const ROOT_URL = process.env.API_URL;
            const config = {
                headers:
                    {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                    }
            };
            axios.get(`${ROOT_URL}/leads/contracts/${this.props.form}`, config)
            .then((response)=> {
                this.setState({
                    contractText: response.data.body,
                    link: response.data.link,
                });
                this.props.dispatch(change(this.props.form, 'contract_accepted', response.data.accepted));
            });
        }
    }

    closeContract() {
        this.setState({ ...this.state, showModal: false });
    }

    openContract() {
        this.setState({ ...this.state, showModal: true });
    }

    acceptContract(dispatch) {
        this.props.dispatch(change(this.props.form, 'contract_accepted', true));
        this.setState({
            showModal: false
        });
    }

    render() {
        const { onSubmit, handleSubmit, submitting, checked, text, label } = this.props;
        const { link, contractText, showModal } = this.state;

        const contractBody = link ? (<PdfBody urlFile={link} />) :
        (<div
            dangerouslySetInnerHTML={{__html: (contractText || text)}}>
        </div>)

        return (
            <Row className="terms_row">
                <Col className="terms_col terms_checkbox text-center" xs={12} md={6} lg={6}>
                    <Field
                        name="contract_accepted"
                        label={label}
                        component={(props) =>
                            <Checkbox checked={props.input.value} onClick={this.openContract}>{label} </Checkbox>
                        }
                    />
                </Col>
                <Col className="terms_col" xs={12} md={6} lg={6}>
                    <Button className={"btn btn-warning btn-sm pd-simple-button " + (checked ? 'pd-button-accepted-contract' : '') }  onClick={this.openContract} disabled={(submitting || checked)}>{submitting ? 'Cargando...' : checked ? 'Leído y aceptado' : 'Por favor, leer y aceptar'}</Button>
                    <Modal className="custom-modal" show={showModal} onHide={this.closeContract} bsSize="large">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Modal.Header>
                                <Modal.Title>{label}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="custom-modal-body" >
                                {contractBody}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    type="submit"
                                    bsStyle="success"
                                    onClick={this.acceptContract}
                                    disabled={
                                        submitting
                                        || (!this.props.hasOwnProperty('text')
                                            && !contractText
                                            && !link)
                                }>
                                        Estoy de Acuerdo
                                </Button>
                                <Button onClick={this.closeContract}>Cancelar</Button>
                            </Modal.Footer>
                        </form>
                    </Modal>
                </Col>
            </Row>
        );
    }
}

Contract = reduxForm()(Contract);

export default Contract;


/** WEBPACK FOOTER **
 ** ./src/components/Contract.js
 **/